<div class="wrapper">
  <mat-icon *ngIf="icon" [color]="color" class="state-icon">{{icon}}</mat-icon>
  <div class="message">
    <span *ngIf="message" class="mat-subtitle-2">{{ message }}</span>
    <span *ngIf="data?.subMessage" class="mat-caption">{{ data.subMessage }}</span>
  </div>
  <div class="actions">
    <ng-container *ngIf="data?.action; else defaultActionTemplate">
      <ng-container *ngIf="!data.action?.text; else textActionTemplate">
        <button (click)="ref.dismissWithAction()" [color]="color" mat-icon-button>
          <mat-icon>close</mat-icon>
        </button>
      </ng-container>
      <ng-template #textActionTemplate>
        <button (click)="ref.dismissWithAction()" [color]="color" mat-button>{{ data.action!.text }}</button>
      </ng-template>
    </ng-container>
    <ng-template #defaultActionTemplate>
      <button (click)="ref.dismiss()" mat-icon-button><mat-icon>close</mat-icon></button>
    </ng-template>
  </div>
</div>
<app-progress-bar
  (done)="ref.dismiss()"
  *ngIf="data.duration && data.duration > 0"
  [color]="color"
  [duration]="data.duration">
</app-progress-bar>
